<template>
  <div class="flex">
    <ItemPreviewCard
      type="div"
      class="cursor-pointer"
      title="Click to change..."
      @click="$emit('change-click')"
    >
      <img
        v-if="$get(element, 'previewImage.src')"
        :src="$get(element, 'previewImage.src')"
        :alt="$get(element, 'previewImage.alt')"
        class="thumb"
      />
    </ItemPreviewCard>

    <div>
      <p v-if="$get(element, 'name')" class="element-name">
        {{ $get(element, "name") }}
      </p>

      <Button class="xs primary" @click="$emit('change-click')">
        Change
      </Button>

      <Button
        class="xs link italic px-1 text-grey-dark mt-1"
        @click="$emit('remove-click')"
      >
        (remove)
      </Button>
    </div>
  </div>
</template>

<script>
import ItemPreviewCard from "@/components/UI/ItemPreviewCard";

export default {
  name: "ElementSelectorCard",
  components: { ItemPreviewCard },
  props: {
    element: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style scoped>
>>> .item-preview-card {
  @apply mr-4;
  padding: 5px;
  width: 144px;
}

.thumb {
  @apply mb-0 block rounded-lg;
  padding: 5px;
}

.element-name {
  @apply font-bold my-2;
}

.element-category {
  @apply flex items-center text-xs text-grey mb-3;

  &:hover {
    @apply no-underline text-brand;
  }
}
</style>
